import React from "react";
import ErrorModal from "./ErrorModal";
import EditProfileModal from "components/EditProfileModal/EditProfileModal";
import ChangePasswordModal from "components/ChangePasswordModal/ChangePasswordModal";
import DeleteAccountModal from "components/DeleteAccountModal/DeleteAccountModal";
import LogoutModal from "components/LogoutModal/LogoutModal";
import UserFlow from "components/UserFlow/UserFlow";
import Snackbar from "components/Snackbar/Snackbar";
import LeaveFeedback from "components/LeaveFeedback/LeaveFeedback";
import { useIsMobile } from "hooks/useIsMobile";
import PromoBanner from "../../components/PromoBanner";
import { useDispatch } from "react-redux";
import { setShowUserFlow } from "store/commonSlice";
import LandingFooter from "pages/Home/components/LandingFooter/LandingFooter";
import Header from "./Header";

interface Props {
  children: React.ReactNode;

  [key: string]: any;
}

const shouldRenderPromo = false;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Layout = ({ children, ...etc }: Props) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const footerRef = React.useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = React.useState(0);

  React.useEffect(() => {
    if (etc?.needLogin) dispatch(setShowUserFlow(true));
  }, []);

  React.useEffect(() => {
    if (etc.hiddenFooter || !footerRef.current) return;
    const observer = new ResizeObserver((entries) => {
      setFooterHeight(entries[0].contentRect.height);
    });

    observer.observe(footerRef.current);

    return () => observer.disconnect();
  }, [etc.hiddenFooter]);

  return (
    <div className="bg-green min-h-screen flex flex-col">
      {!etc.hiddenHeader && <Header />}
      <main className="flex-1 flex flex-col relative bg-white" style={{ zIndex: 1 }}>
        {!isMobile && shouldRenderPromo && <PromoBanner />}
        <EditProfileModal />
        <ChangePasswordModal />
        <DeleteAccountModal />
        <LogoutModal />
        <UserFlow />
        <Snackbar />
        <LeaveFeedback />
        {children}
        {/* {isMobile && <MobileMenuBar />} */}
        <ErrorModal />
      </main>
      {/* Transparent spacer: creates scroll depth so the fixed footer is revealed at scroll-end.
          The outer div's bg-green shows through here, matching the footer color. */}
      {!etc.hiddenFooter && <div style={{ height: footerHeight, flexShrink: 0 }} />}
      {!etc.hiddenFooter && (
        <div ref={footerRef} style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 0 }}>
          <LandingFooter />
        </div>
      )}
    </div>
  );
};

export default Layout;
